// src/components/Footer.tsx
import { Box, Container, Grid, Typography, Link, Stack, Divider } from "@mui/material";

export const Footer = () => (
  <Box sx={{ bgcolor: "#051628", color: "white", pt: 8, pb: 4 }}>
    <Container maxWidth="lg">
      <Grid container spacing={4} sx={{ mb: 4 }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="h6" fontWeight={900} gutterBottom>
            NETCOMSERVE
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.7, lineHeight: 2 }}>
            A vibrant, dynamic and innovative start-up venture serving as a one-stop solution provider for mundane and
            critical IT issues.
          </Typography>
        </Grid>

        <Grid size={{ xs: 6, md: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Solutions
          </Typography>
          <Stack spacing={1}>
            <Link href="#" color="inherit" underline="none" variant="body2" sx={{ opacity: 0.7 }}>
              Microsoft Enterprise
            </Link>
            <Link href="#" color="inherit" underline="none" variant="body2" sx={{ opacity: 0.7 }}>
              Network Security
            </Link>
            <Link href="#" color="inherit" underline="none" variant="body2" sx={{ opacity: 0.7 }}>
              Cloud Migration
            </Link>
          </Stack>
        </Grid>

        <Grid size={{ xs: 6, md: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Technologies
          </Typography>
          <Stack spacing={1}>
            <Link href="#" color="inherit" underline="none" variant="body2" sx={{ opacity: 0.7 }}>
              Linux & Open Source
            </Link>
            <Link href="#" color="inherit" underline="none" variant="body2" sx={{ opacity: 0.7 }}>
              Android Apps
            </Link>
            <Link href="#" color="inherit" underline="none" variant="body2" sx={{ opacity: 0.7 }}>
              Web Development
            </Link>
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Core Values
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            Performance • Integrity • Initiative • Ownership • Teamwork
          </Typography>
        </Grid>
      </Grid>

      <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", mb: 4 }} />

      <Typography variant="body2" align="center" sx={{ opacity: 0.5 }}>
        © {new Date().getFullYear()} Netcomserve Global Services Limited. All rights reserved.
      </Typography>
    </Container>
  </Box>
);
